export default __webpack_public_path__ + "static/media/sign-up-blobs.128f4520.svg";